require('./services/user-payment');

module.exports = 'user-payment';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/user-payment/index.js
 ** module id = 118
 ** module chunks = 1
 **/